import { useState, useEffect, useCallback } from 'react';
import { useToast } from '@chakra-ui/react';
import { trainerDashboardService, TrainerDashboardStats } from './trainerDashboardService';

export interface UseTrainerDashboardResult extends TrainerDashboardStats {
    refreshStats: () => Promise<void>;
}

export const useTrainerDashboard = (): UseTrainerDashboardResult => {
    const [stats, setStats] = useState<TrainerDashboardStats>({
        totalClients: 0,
        activeClients: 0,
        trainerCode: '',
        trainerName: '',
        isLoading: true,
        error: null,
    });

    const toast = useToast();

    const fetchStats = useCallback(async () => {
        setStats(prev => ({ ...prev, isLoading: true, error: null }));

        try {
            const dashboardStats = await trainerDashboardService.getDashboardStats();
            setStats({
                ...dashboardStats,
                isLoading: false,
                error: null,
            });
        } catch (error: any) {
            const errorMessage = error.message || 'Failed to fetch dashboard statistics';
            setStats(prev => ({
                ...prev,
                isLoading: false,
                error: errorMessage,
            }));

            toast({
                title: 'Error',
                description: errorMessage,
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        }
    }, [toast]);

    const refreshStats = useCallback(async () => {
        await fetchStats();
    }, [fetchStats]);

    useEffect(() => {
        fetchStats();
    }, [fetchStats]);

    return {
        ...stats,
        refreshStats,
    };
};
